import camelize from 'camelize';
import { compose, lifecycle, mapProps, withHandlers, withStateHandlers } from 'recompose';
import config from '../../../config';
import { withSpinnerWhileLoading, withSpinnerOnAjax } from '../Spinner';

export const getBySlug = slug => $.get(`${config.localeApi}/configurable_products/${slug}`);

export const withConfigurableProductData = WrappedComponent => compose(
  withStateHandlers({
    loading: true,
    data: {},
  }, {
    handleAsyncDone: () => data => ({
      loading: false,
      data,
    }),
  }),
  lifecycle({
    componentDidMount() {
      const {
        handleAsyncDone,
        params: { slug } = {},
      } = this.props;

      getBySlug(slug)
        .done(({ data }) => handleAsyncDone(data))
        .fail(() => {
          window.location.pathname = '/404.html';
        });
    },
  }),
  withSpinnerWhileLoading,
  mapProps(({ data, ...props }) => ({
    data: camelize(data),
    ...props,
  })),
)(WrappedComponent);

export const addConfigurableProductToCart = ( productCode, configs, selectedSku ) => {
  return $.ajax({
    url: `${config.localeApi}/cart/configurable_project`,
    data: {
      product_code: productCode,
      steps: Object.keys(configs).map(key => ({
            code: key,
            value: configs[key],
        })),
      sku: selectedSku
    },
    method: 'POST',
    dataType: 'json',
  });
};

export const addReorderConfigurableProductToCart = ( projectId, productCode, productSku ) => {
  return $.ajax({
    url: `${config.localeApi}/cart/reorder_configurable_project`,
    data: {
      project_id : projectId,
      product_code: productCode,
      sku: productSku
    },
    method: 'POST',
    dataType: 'json',
  });
};

const getProducts = (partner, category, page, sort) => $.get(`${config.localeApi}/partners/${partner}/categories/${category}?page=${page}&sort=${sort}&limit=16`);

export const WithPartnerCategoryProducts = WrappedComponent => compose(
  withSpinnerOnAjax('getProducts', getProducts),
  withStateHandlers({
    loading: true,
    data: {},
  }, {
    handleAsyncDone: () => data => ({
      loading: false,
      data,
    }),
  }),
  withHandlers({
    getProductsAPI: ({ handleAsyncDone, getProducts }) => (partner, category, page, sort) => {
      getProducts(partner, category, page, sort)
        .done(({ data }) => {
          handleAsyncDone(data);
          window.history.pushState(null, null, window.location.pathname + `?page=${page}&sort=${sort}`);
        })
        .fail(() => {
          window.location.href = window.location.origin + '/404.html';
        });
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        partner,
        category,
        page,
        sort,
        getProductsAPI
      } = this.props;
      getProductsAPI(partner, category, page, sort)
    },
  }),
  withSpinnerWhileLoading,
  mapProps(({ data, ...props }) => ({
    data: camelize(data),
    ...props,
  })),
)(WrappedComponent);

export function fetchPcpProductConfigsData(productConfigs) {
  const query = productConfigs.map(config => `configs[]=${config}`).join('&');
  return $.get(`${config.localeApi}/pcp_product_configs?${query}`);
}



// WEBPACK FOOTER //
// ./src/Common/Providers/ConfigurableProductApi.js